import { TextField, Tooltip } from '@mui/material';
import { action, observable, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { ComplementoGEDTO, ComplementosPossiveisDto, MovimentoGEDTO } from '../../modelo/MinutaMovimentos';
import MovimentoService from '../../services/MovimentoService';

interface IPropsComplementoTextField {
    complemento: ComplementosPossiveisDto;
    movimento: MovimentoGEDTO;
    callbackAtualizarComplementos: (nomeDominio: string, complemento: ComplementoGEDTO, excluir: boolean) => any;
    complementos: ComplementoGEDTO[];
}

const MOVIMENTOS_QUE_ACEITAM_APENAS_NUMEROS = ['P-265', 'P-50107', 'P-14973'];

class ComplementoTextField extends React.Component<IPropsComplementoTextField> {
    valor: string = this.props.movimento.complementos?.find(comp => comp.stringComplemento === this.props.complemento.stringComplemento)?.valorSetado || '';

    onChangeComplemento = (e) => {
        const complemento = this.props.complemento;
        const valor = e.target.value;
        let complementoModificado = this.props.complementos.find(comp => comp.stringComplemento === complemento.stringComplemento);
        if (!complementoModificado) {
            complementoModificado = ComplementoGEDTO.fromPossivelToGEDTO(complemento);
        }
        complementoModificado.valorSetado = valor;
        complementoModificado.valorComplemento = valor;
        this.valor = valor;
        this.props.callbackAtualizarComplementos(complemento.stringComplemento, complementoModificado, !valor);
    };

    apenasNumeros = (e) => {
        if (MOVIMENTOS_QUE_ACEITAM_APENAS_NUMEROS.includes(this.props.movimento.codMovimentoCnj)) {
            if (e.key === '.' || e.key === ',' || e.key === 'e' || e.key === '+') {
                e.preventDefault();
            }
        }
    }

    constructor(props: IPropsComplementoTextField) {
        super(props);

        makeObservable(this, {
            valor: observable,
            onChangeComplemento: action,
        });
    }

    getMovimentosExcludentes(movimento: MovimentoGEDTO): string[][] {

        const descricaoMovimento = movimento?.descricaoMovimento || '';
        return descricaoMovimento.match(/#\{[A-Za-zÀ-ÖØ-öø-ÿ\s]*}(?:\s*\/\s*(#\{)?[A-Za-zÀ-ÖØ-öø-ÿ\s]*}){1,}/gi)?.map(a => a.replace(/#{|}/g, '').split('/').map(b => b.trim()));
    }


    get isDisabled(): boolean {
        const nomeDominio: string = this.props.complemento.stringComplemento;
        const excludente = MovimentoService.existeComplementoExcludente(nomeDominio, this.props.movimento);
        let compExcludente: ComplementoGEDTO;
        if (excludente?.length) {
            compExcludente = this.props.complementos.find(comp => excludente.includes(comp.stringComplemento));
        }
        return !!compExcludente?.valorSetado;
    }

    render() {
        return (
            <Tooltip title={this.isDisabled ? 'Os complementos são excludentes, portanto preencha apenas um dos campos.' : this.valor ? '' : 'Preencha o complemento'}>
                <TextField key={this.props.movimento.codMovimentoCnj + this.props.complemento.stringComplemento}
                    fullWidth
                    type={MOVIMENTOS_QUE_ACEITAM_APENAS_NUMEROS.includes(this.props.movimento.codMovimentoCnj) ? 'number' : 'text'}
                    label={this.props.complemento.stringComplemento[0].toUpperCase() + this.props.complemento.stringComplemento.substring(1)}
                    value={this.valor}
                    onChange={this.onChangeComplemento}
                    onKeyDown={this.apenasNumeros}
                    disabled={this.isDisabled}
                />
            </Tooltip>
        );
    }
}

export default observer(ComplementoTextField);
